export enum ActivityType {
  PLACEMENT_TEST = 'Placement Test',
  LIVE_CLASS = 'Live Class',
  PRIVATE_CLASS = 'Private Class',
  PRACTICE = 'Practice',
  LESSON = 'Lesson',
  UNIT_ASSESSMENT = 'Unit Assessment',
  NEWS = 'News',
  LEVEL_ZERO = 'Level Zero',
  IDIOMS = 'Idioms',
}



// WEBPACK FOOTER //
// ./ts/app/activity-calendar/activity-snippet/activity-type.ts